<body id="operation-pickup">
  <div class="operation-pickup-table-container">
    <table mat-table matSort [dataSource]="dataSource">
      <caption>
        Pickup
      </caption>
      <!-- Route -->
      <ng-container matColumnDef="route">
        <th mat-header-cell *matHeaderCellDef id="route-header">
          <app-table-search-component
            [columnName]="HEADERS.ROUTE"
            [control]="routeData.formControl"
            [maxLength]="3"
            (emitSearch)="search()"
          ></app-table-search-component>
          <img
            class="sort-route"
            id="sort-by-route"
            alt="sort"
            onkeypress="showRouteSortDropdown = true"
            [src]="SRC.SORT"
            (click)="showRouteSortDropdown = true"
          />
          <ion-popover
            trigger="sort-by-route"
            triggerAction="click"
            [isOpen]="showRouteSortDropdown"
            (didDismiss)="showRouteSortDropdown = false"
            cssClass="sort-by-route-popover"
          >
            <ng-template>
              <ion-content>
                <ion-item-group>
                  <ion-item
                    class="dropdown-option"
                    lines="none"
                    (click)="
                      sortDataSource('asc'); showRouteSortDropdown = false
                    "
                    onkeypress="
                      sortDataSource('asc');
                      showRouteSortDropdown = false;
                    "
                  >
                    <img [src]="SRC.SORT_UP" alt="sort" />
                    <ion-label class="label">
                      {{ HEADERS.SORT_BY_UNASSIGNED }}
                    </ion-label>
                  </ion-item>
                  <ion-item
                    class="dropdown-option"
                    lines="none"
                    (click)="
                      sortDataSource('desc'); showRouteSortDropdown = false
                    "
                    onkeypress="
                      sortDataSource('desc');
                      showRouteSortDropdown = false;
                    "
                  >
                    <img [src]="SRC.SORT_DOWN" alt="sort" />
                    <ion-label class="label">
                      {{ HEADERS.SORT_BY_ASSIGNED }}
                    </ion-label>
                  </ion-item>
                </ion-item-group>
              </ion-content>
            </ng-template>
          </ion-popover>
        </th>
        <td
          mat-cell
          *matCellDef="let pickup; let i = index"
          headers="route-headers"
          class="left-data-column"
        >
          @if (!!pickup.isRouteAssigned) {
            <div class="reassign-route-wrapper">
              <span>{{ pickup.route }} </span>
              @if (pickup.stopType === STOPS[0].id) {
                <img
                  class="edit-route"
                  alt="edit-route"
                  onkeypress="reassignRoute(pickup)"
                  [src]="SRC.EDIT_BLUE"
                  (click)="reassignRoute(pickup)"
                />
              }
            </div>
          }
          @if (!pickup.isRouteAssigned && pickup.stopType === STOPS[0].id) {
            <div class="unassigned-route">
              <ng-select
                #routes
                appendTo="body"
                appearance="outline"
                class="custom-select"
                [items]="summaryRoutes"
                [searchable]="true"
                [clearable]="true"
                [(ngModel)]="pickup.route"
                [ngModelOptions]="{ standalone: true }"
                (change)="changedRouteOptions($event, pickup)"
              >
                @for (route of summaryRoutes; track route) {
                  <ng-option [value]="route">
                    {{ route }}
                  </ng-option>
                }
              </ng-select>
            </div>
          }
        </td>
      </ng-container>

      <!-- Stop Type -->
      <ng-container matColumnDef="stopType">
        <th mat-header-cell *matHeaderCellDef id="stopType-headers">
          <app-table-dropdown-status
            [header]="HEADERS.STOP_TYPE"
            [data]="stopTypeData"
            [hasWarningSymbol]="false"
            [resetData]="resetSelectDropdowns"
            [operationsIcons]="true"
            [showDropdown]="stopTypeDropdownOpen[0]"
            (dropdownChange)="
              stopTypeDropdownOpen = commonUtils.updateDropdown(
                stopTypeDropdownOpen,
                0
              )
            "
            (emitStatusChange)="
              onStatusChangeForDropdowns($event, stopTypeData)
            "
          >
          </app-table-dropdown-status>
        </th>
        <td
          mat-cell
          *matCellDef="let pickup; let i = index"
          headers="stopType-headers"
          class="center-data-column"
        >
          <div class="stop-content-type">
            <img
              class="color-active"
              [src]="pickup.stopType === STOPS[0].id ? SRC.PHONE : SRC.PICKUP"
              alt="stop type"
              #tooltip="matTooltip"
              [matTooltip]="
                pickup.stopType === STOPS[0].id
                  ? TOOLTIP_TEXT.ON_DEMAND
                  : TOOLTIP_TEXT.SCHEDULED
              "
              [matTooltipPosition]="'right'"
            />
            @if (pickup.collectionAmount && pickup.pickupPaymentCode == "08") {
              $ Prepaid
            } @else if (pickup.collectionAmount) {
              $
            } @else if (pickup.pickupPaymentCode == "08") {
              Prepaid
            }
          </div>
        </td>
      </ng-container>

      <!-- IDO suggestion -->
      <ng-container matColumnDef="IDOsuggestion">
        <th mat-header-cell *matHeaderCellDef id="ido-suggestions-headers">
          <app-table-search-component
            [columnName]="HEADERS.IDO_SUGGESTION"
            [control]="IDOsuggestionData.formControl"
            [maxLength]="3"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let pickup; let i = index"
          headers="ido-suggestions-headers"
          class="left-data-column"
        >
          {{ pickup.IDOsuggestion }}
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef id="status-headers">
          <app-table-header-dropdown
            [columnText]="HEADERS.STATUS"
            [itemId]="statusData.itemId"
            [searchResults]="PICKUP_STATUS"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[0]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 0)
            "
            (checkboxesUpdated)="onStatusChangeForDropdowns($event, statusData)"
          >
          </app-table-header-dropdown>
        </th>
        <td mat-cell *matCellDef="let pickup" headers="status-headers">
          {{ pickup.status }}
        </td>
      </ng-container>

      <!-- Package Type -->
      <ng-container matColumnDef="packageType">
        <th mat-header-cell *matHeaderCellDef id="package-type-headers">
          <app-table-header-dropdown
            [columnText]="HEADERS.PACKAGE_TYPE"
            [itemId]="packageTypeData.itemId"
            [searchResults]="PACKAGES"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[1]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 1)
            "
            (checkboxesUpdated)="
              onStatusChangeForDropdowns($event, packageTypeData)
            "
          >
          </app-table-header-dropdown>
        </th>
        <td
          mat-cell
          *matCellDef="let pickup; let i = index"
          headers="package-type-headers"
        >
          {{ pickup.packageType }}
        </td>
      </ng-container>

      <!-- Shipper / PRN -->
      <ng-container matColumnDef="shipperPrn">
        <th mat-header-cell *matHeaderCellDef id="shipper-headers">
          <app-table-search-component
            [columnName]="HEADERS.SHIPPER_PRN"
            [control]="shipperPrnData.formControl"
            [maxLength]="11"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let pickup; let i = index"
          headers="shipper-headers"
          class="left-data-column shipper"
        >
          <div
            id="shipper-prn"
            (click)="
              pickup.stopType === 'Scheduled'
                ? openScheduledPickup(pickup)
                : openOnDemandPickup(pickup)
            "
            onkeydown="
              pickup.stopType === 'Scheduled'
                ? openScheduledPickup(pickup)
                : openOnDemandPickup(pickup)
            "
          >
            {{ pickup.shipperPrn }}
          </div>
        </td>
      </ng-container>

      <!-- Street Address -->
      <ng-container matColumnDef="streetAddress">
        <th mat-header-cell *matHeaderCellDef id="street-address-headers">
          <app-table-search-component
            [columnName]="HEADERS.STREET_ADDRESS"
            [control]="streetAddressData.formControl"
            [allowedSpecialChars]="SPECIAL_CHARS.SPACE"
            [maxLength]="30"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let pickup; let i = index"
          headers="street-address-headers"
          class="left-data-column address"
        >
          @if (
            pickup.addressCorrected &&
            pickup.stopType === STOPS[0].id &&
            pickup.streetAddress?.trim().length > 0
          ) {
            <img class="address-warning" [src]="SRC.YIELD" alt="warning" />
          }
          <div class="customer-data-item">
            @if (
              pickup.streetAddress?.trim().length > 0 &&
              !pickup.latValue &&
              !pickup.longValue &&
              pickup.idoEnabled
            ) {
              <span class="no-lat-long">!</span>
            }
            <div>{{ pickup.customerName }}</div>
          </div>
          {{ pickup.streetAddress }}
        </td>
      </ng-container>

      <!-- City -->
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef id="city-headers">
          <app-table-search-component
            [allowedSpecialChars]="SPECIAL_CHARS.SPACE"
            [columnName]="HEADERS.CITY"
            [control]="cityData.formControl"
            [maxLength]="3"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let pickup; let i = index"
          headers="city-headers"
          class="left-data-column"
        >
          {{ pickup.city }}
        </td>
      </ng-container>

      <!-- Postal -->
      <ng-container matColumnDef="postal">
        <th mat-header-cell *matHeaderCellDef id="postal-headers">
          <app-table-search-component
            [columnName]="HEADERS.POSTAL"
            [control]="postalData.formControl"
            [maxLength]="6"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let pickup; let i = index"
          headers="postal-headers"
          class="left-data-column postal"
        >
          {{ pickup.postal }}
        </td>
      </ng-container>

      <!-- Ready Time -->
      <ng-container matColumnDef="readyTime">
        <th mat-header-cell *matHeaderCellDef id="ready-time-headers">
          <app-table-search-component
            [columnName]="HEADERS.READY_TIME"
            [control]="readyTimeData.formControl"
            [maxLength]="5"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let pickup; let i = index"
          headers="ready-time-headers"
          class="left-data-column ready-time"
        >
          {{ pickup.readyTime }}
        </td>
      </ng-container>

      <!-- Commit Time -->
      <ng-container matColumnDef="commitTime">
        <th mat-header-cell *matHeaderCellDef id="commit-time-headers">
          <app-table-search-component
            [columnName]="HEADERS.COMMIT_TIME"
            [control]="commitTimeData.formControl"
            [maxLength]="5"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let pickup; let i = index"
          headers="commit-time-headers"
          class="left-data-column commit-time"
        >
          {{ pickup.commitTime }}
        </td>
      </ng-container>

      <!-- Complete Time -->
      <ng-container matColumnDef="completeTime">
        <th mat-header-cell *matHeaderCellDef id="complete-time-headers">
          <app-table-search-component
            [columnName]="HEADERS.COMPLETE_TIME"
            [control]="completeTimeData.formControl"
            [maxLength]="5"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let pickup; let i = index"
          headers="commit-time-headers"
          class="left-data-column commit-time"
        >
          {{ pickup.completeTime ? pickup.completeTime : "-" }}
        </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef id="actions-headers">
          <ion-row class="th-text">{{ ACTIONS_TEXT }}</ion-row>
          <ion-row class="search-wrapper search-header-labels">
            <button
              [class]="
                changedRoutes.length > 0 ? 'active-check' : 'inactive-check'
              "
              [disabled]="changedRoutes.length === 0"
              (click)="assignReassignRoute()"
              [disabled]="!(changedRoutes.length > 0)"
            >
              <img [src]="IMAGES.CHECK_WHITE" alt="done" />
            </button>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="actions-headers"
        ></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns; let i = index"
      ></tr>
      <tr class="mat-row no-results" *matNoDataRow>
        <td class="mat-cell no-border" [attr.colspan]="displayedColumns.length">
          <app-no-results-found></app-no-results-found>
        </td>
      </tr>
    </table>
  </div>
  <app-table-pagination [datasource]="dataSource"></app-table-pagination>
</body>
